import { PropertyDefinition } from 'hs-resources/resources/PropertyDefinition';
const getMetadata = async (objectTypeId, propertyName, httpClient) => {
  var _data$externalOptions;
  const {
    data
  } = await PropertyDefinition.getPromise({
    objectTypeId,
    propertyName
  }, {
    httpClient
  });
  return (_data$externalOptions = data === null || data === void 0 ? void 0 : data.externalOptionsMetaData) !== null && _data$externalOptions !== void 0 ? _data$externalOptions : undefined;
};
export const maybeGetExternalOptionsMetaData = async (objectTypeId, propertyName, httpClient) => {
  if (objectTypeId && propertyName) {
    try {
      const metadata = await getMetadata(objectTypeId, propertyName, httpClient);
      return metadata;
    } catch (e) {
      // Do nothing
    }
  }
  return undefined;
};